import { ChartOption, ChartOptionElement } from 'gqlTypes'
import { atomFamily, selectorFamily } from 'recoil'

export const keyForElementIdAndType = ({
  id,
  type,
  reportId,
}: {
  id: string
  type: ChartOptionElement
  reportId?: string
}) => {
  const key = [type, id].join(':')
  if (type != ChartOptionElement.Report) {
    const reportKey = [ChartOptionElement.Report, reportId].join(':')
    return [reportKey, key].join('::')
  }
  return key
}

export const chartOptionAtom = atomFamily<Partial<ChartOption>, string>({
  key: 'chartOption',
  default: {},
})

export const chartOptionsForPath = selectorFamily<Partial<ChartOption>, string>(
  {
    key: 'chartOptionsForPath',
    get:
      (path) =>
      ({ get }) =>
        path
          .split('/')
          .map((k) => get(chartOptionAtom(k)))
          .reduce((acc, value) => ({ ...acc, ...value }), {}),
  }
)
